<div mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    <mat-icon class="w-25 h-100" [svgIcon]="makeIcon"></mat-icon>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid">
        <div class="row" [formGroup]="makeForm">
            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>Name</mat-label>
                <mat-error>You need to enter a name</mat-error>
                <input matInput placeholder="Ex: Add user to crm" formControlName="name" required>
                <mat-hint>Enter the name that defines your make action</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100 mb-3">
                <mat-label>make webhook</mat-label>
                <mat-error>You need to enter the webhook</mat-error>
                <input matInput placeholder="Ex: 15784/7846sd" formControlName="makeId">
                <mat-hint>Enter the webhook your make</mat-hint>
            </mat-form-field>
            <app-form-entries [formEntryForm] = "makeForm" [formEntries]="this.data.make?.formEntries || []"></app-form-entries>
        </div>
    </div>
</mat-dialog-content>

<!-- Test make button -->
<mat-divider></mat-divider>
<button [disabled]="!makeForm.valid || isLoading" (click)="onTestMake()" mat-raised-button class="d-block mx-auto mt-4 mb-4" color="primary">
    <span *ngIf="!isMakeTestLoading">
        Test make
    </span>
    <mat-spinner *ngIf="isMakeTestLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
</button>
<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn" [disabled]="isLoading">Close</button>
    <button (click)="onSubmit()" mat-raised-button class="w-25" color="primary"
        [disabled]="!makeForm.valid || isLoading">
        <span *ngIf="!isMakeSaveLoading">
            {{data.make ?'Save' : 'Add'}}
        </span>
        <mat-spinner *ngIf="isMakeSaveLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>